export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
export const FETCH_CATEGORY_BEGIN = "FETCH_CATEGORY_BEGIN";
export const FETCH_CATEGORY_SUCCESS = "FETCH_CATEGORY_SUCCESS";
export const FETCH_CATEGORY_ERROR = "FETCH_CATEGORY_ERROR";
export const FETCH_MEALS_BEGIN = "FETCH_MEALS_BEGIN";
export const FETCH_MEALS_SUCCESS = "FETCH_MEALS_SUCCESS";
export const FETCH_MEALS_ERROR = "FETCH_MEALS_ERROR";
export const FETCH_SINGLE_MEAL_BEGIN = "FETCH_SINGLE_MEAL_BEGIN";
export const FETCH_SINGLE_MEAL_SUCCESS = "FETCH_SINGLE_MEAL_SUCCESS";
export const FETCH_SINGLE_MEAL_ERROR = "FETCH_SINGLE_MEAL_ERROR";
export const FETCH_CATEGORY_MEALS_BEGIN = "FETCH_CATEGORY_MEALS_BEGIN";
export const FETCH_CATEGORY_MEALS_SUCCESS = "FETCH_CATEGORY_MEALS_SUCCESS";
export const FETCH_CATEGORY_MEALS_ERROR = "FETCH_CATEGORY_MEALS_ERROR";

